<template>
  <article :class="className">
    <a href="/">
      <div class="card-download__shape">
        <div class="card-download__shape--oval" v-if="shape == 'oval'">
          <OvalSVG />
        </div>
        <div
          class="card-download__shape--rectangle"
          v-if="shape == 'rectangle'"
        >
          <RectangleSVG />
        </div>
        <div class="card-download__shape--triangle" v-if="shape == 'triangle'">
          <TriangleSVG />
        </div>
      </div>
      <div class="card-download__inner">
        <h3>
          <span class="card-download__subtitle">Report</span>
          <TextHeading variant="title" wide>{{ title }}</TextHeading>
        </h3>
        <BaseButton
          :class="iconColor"
          class="mt-4 text-primary"
          rounded="full"
          variant="white"
          width="small"
          aria-label="Download Report"
        >
          <BaseIcon name="get_app" size="22"></BaseIcon>
        </BaseButton>
      </div>
      <div class="card-download__hover"></div>
    </a>
  </article>
</template>

<script>
import TextHeading from '../elements/TextHeading.vue'
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import OvalSVG from '@/assets/svg/shapes/oval.svg?inline'
import TriangleSVG from '@/assets/svg/shapes/triangle.svg?inline'
import RectangleSVG from '@/assets/svg/shapes/rectangle.svg?inline'

export default {
  name: 'CardDownload',
  components: {
    OvalSVG,
    TriangleSVG,
    RectangleSVG,
    BaseButton,
    BaseIcon,
    TextHeading
  },
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    variant: {
      type: String,
      default: 'primary',
      validator: function(value) {
        return ['primary', 'secondary', 'tertiary'].indexOf(value) !== -1
      }
    },
    iconColor: {
      type: String,
      default: null
    },
    shape: {
      type: String,
      default: 'oval',
      validator: function(value) {
        return ['oval', 'triangle', 'rectangle'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    className() {
      return `card-download card-download--${this.variant}`
    }
  }
}
</script>

<style lang="postcss">
.card-download {
  @apply flex-1 bg-gradient-br-primary text-white relative cursor-pointer overflow-hidden;
}
.card-download a {
  @apply no-underline text-white;
}
.card-download__inner {
  @apply p-6 z-20 relative overflow-hidden h-full flex flex-col;
}
.card-download__hover {
  @apply absolute inset-y-0 inset-x-0 bg-primary z-10 opacity-0;
}
.card-download__subtitle {
  @apply text-white text-sm block font-normal tracking-wide;
}
.card-download:hover .card-download__hover {
  @apply opacity-75;
}
.card-download:hover .card-download__shape {
  transform: scale(1.1);
}
.card-download__shape {
  @apply inset-0 absolute;
}
.card-download__shape svg {
  @apply absolute bottom-0 right-0 hidden;
}
.card-download__shape--oval svg,
.card-download__shape--triangle svg,
.card-download__shape--rectangle svg {
  @apply block;
}
.card-download button {
  @apply mt-auto;
}
.card-download h3 {
  @apply mb-8;
}
@screen lg {
  .page--sidebar .card-download {
    @apply mb-16;
  }
}
</style>
